import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Container, Modal, Row } from 'react-bootstrap';
import { cropInfectionApi, getFormList, submitInfection } from 'api/infection';
import { jwtDecode } from 'jwt-decode';
import { get, isEmpty } from 'lodash';
import useApi from 'hooks/useApi';
import DynamicForm from 'screens/common/dynamicForm';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useNavigate } from 'react-router-dom';
import { farmerReportApi } from 'api/endpoints/farmers';
import { formSubmissionToast } from 'helpers/utils';
import { getTenantFromToken } from 'utils/routeUtils';

function FarmerSms(props) {
  const tenant = getTenantFromToken();
  const tns_tenant = '03534add672340809e2c70314b1ce20e';
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [farmerCount, setFarmerCount] = useState(0);
  const [formData, setFormData] = useState(null);

  const fetchFormData = async () => {
    try {
      const formResponse = await farmerReportApi.getDynamicForm(tns_tenant);
      // console.log(formResponse, 'formResponse');
      setData(formResponse.data.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
    }
  };

  useEffect(() => {
    fetchFormData();
  }, [tns_tenant]);

  // const handleFormSubmit = async formData => {
  //   setShowModal(true);
  //   setFarmerCount(0);
  //   let formatedData = {
  //     ...formData,
  //     block: formData.block || [],
  //     district: formData.district || [],
  //     state: formData.state || '',
  //     village: formData.village || [],
  //     farmer_group: formData.farmer_group || []
  //   };
  //   try {
  //     const response = await farmerReportApi.sendFarmerSms(
  //       tns_tenant,
  //       formatedData
  //     );
  //     const message = response?.data?.desc;
  //     navigate(`/${tenant}/sms-management/`);
  //     toast.success(`${message}`);
  //   } catch (err) {
  //     toast.error(`Failed to send SMS`);
  //   }
  // };

  const handleFormSubmit = async data => {
    setFarmerCount(data?.total_farmer_count || 0); // Get farmer count
    setFormData(data); // Store form data for later use
    setShowModal(true); // Show confirmation modal
  };

  const confirmSendSms = async () => {
    setShowModal(false); // Close modal

    let formatedData = {
      ...formData,
      block: formData.block || [],
      district: formData.district || [],
      state: formData.state || '',
      village: formData.village || [],
      farmer_group: formData.farmer_group || []
    };
    try {
      const response = await farmerReportApi.sendFarmerSms(
        tns_tenant,
        formatedData
      );
      navigate(`/${tenant}/smslogReport/`);
      formSubmissionToast(response, toast, 'SMS Log');
    } catch (err) {
      formSubmissionToast(err, toast, 'SMS Log');
    }
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}/farmerReport`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>Create Farmer SMS</span>
    </div>
  );

  return (
    <>
      <Container>
        <Row>
          <Card className="mb-3">
            <Card.Header>
              <FalconCardHeader
                title={header}
                className="ps-lg-4"
                titleTag="h5"
                titleClass="mb-0"
                light
              />
            </Card.Header>
            <Card.Body>
              {!isEmpty(data) && (
                <DynamicForm
                  data={data}
                  header={true}
                  onSubmit={handleFormSubmit}
                />
              )}
            </Card.Body>
          </Card>
        </Row>
      </Container>
      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm SMS Sending</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to send this message to {farmerCount} farmers?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmSendSms}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

FarmerSms.propTypes = {};

export default FarmerSms;
